import { render } from "./SurveyModal.vue?vue&type=template&id=ed8b0fdc"
import script from "./SurveyModal.vue?vue&type=script&lang=js"
export * from "./SurveyModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__